<template>
  <div>
    <v-card>
      <v-toolbar color="primary" class="white--text" dense>
        <v-icon left color="white">mdi-card-account-details</v-icon>
        Temporary License
      </v-toolbar>
      <v-card-subtitle
        ><span class="font-weight-bold">License Class:</span>
        <span>
          {{ testData[selectedIndex].LicenseClass }}</span
        ></v-card-subtitle
      >
      <v-card-text>
        <v-row>
          <v-col
            ><span class="font-weight-bold">DMV ID Number:</span>
            {{ testData[selectedIndex].CID }}</v-col
          >
          <v-col v-if="endorsementsDisplay">
            <div class="font-weight-bold">
              Endorsements:
              <span class="font-weight-regular">{{ endorsementsDisplay }}</span>
            </div>
          </v-col>
          <v-col v-if="addRestrictionsDisplay || removeRestrictionsDisplay"
            ><div class="font-weight-bold">
              Restrictions:
            </div>
            <ul>
              <li v-if="addRestrictionsDisplay">
                Add: {{ addRestrictionsDisplay }}
              </li>
              <li v-if="removeRestrictionsDisplay">
                Remove: {{ removeRestrictionsDisplay }}
              </li>
            </ul></v-col
          >
        </v-row>
        <v-row>
          <v-col
            v-if="
              testData[selectedIndex].OverallResult == 'Pass' &&
                (testData[selectedIndex].LicenseClass == 'Class D' ||
                  testData[selectedIndex].LicenseClass == 'Class DJ')
            "
          >
            Please print your receipt. It will serve as your temporary interim
            license. This temporary license expires 60 days from the date of the
            test. Keep it with your photo learner permit. You will receive your
            photo driver license in the mail, in about 2 weeks. Please do not go
            to a DMV office.
          </v-col>
          <v-col
            v-if="
              testData[selectedIndex].OverallResult == 'Pass' &&
                testData[selectedIndex].IsCDLTest
            "
          >
            You must keep this receipt and wait 1 business day before visiting a
            DMV office in order to obtain a Commercial Driver’s License (CDL)
            document.
          </v-col>
          <v-col
            v-if="
              testData[selectedIndex].OverallResult == 'Pass' &&
                (testData[selectedIndex].LicenseClass == 'Class M' ||
                  testData[selectedIndex].LicenseClass == 'Class MJ')
            "
          >
            Please print your receipt to serve as your temporary interim
            license. This temporary license expires 60 days from the date of
            your road test. Keep the receipt with your learner permit.
            <span class="font-weight-bold"
              >If you already have another class of New York State driver
              license,</span
            >
            wait at least 7 days after your road test to apply for your
            motorcycle license at a DMV office. If you do not have another class
            of New York State driver license, you will receive your motorcycle
            license with your photo by mail about 2 weeks after your road test
            (you do not have to visit a DMV office).
          </v-col>
        </v-row>
        <!-- <v-row v-if="testData[selectedIndex].OverallResult == 'Pass'">
          <v-col>
            You must sign this document to validate your temporary interim
            license.
            <br />
            <br />
          </v-col>
        </v-row>
        <v-row v-if="testData[selectedIndex].OverallResult == 'Pass'">
          <v-col>
            <hr />
            Signature
          </v-col>
        </v-row> -->
      </v-card-text>
      <v-card-actions>
        <v-btn
          class="justify-center d-print-none"
          color="primary"
          @click="goBack()"
        >
          <v-icon>
            mdi-arrow-left
          </v-icon>
          Go Back
        </v-btn>
        <v-btn
          class="justify-center d-print-none"
          color="primary"
          @click="myWindow.print()"
        >
          <v-icon>
            mdi-printer
          </v-icon>
          Print Temporary License
        </v-btn>
      </v-card-actions>
    </v-card>
    <!-- <pre>Test Data: {{ testData[selectedIndex] }}</pre> -->
  </div>
</template>

<script>
export default {
  name: 'Receipt',
  props: {
    testData: {
      type: Array,
      required: true,
    },
    selectedIndex: {
      type: Number,
      required: true,
    },
  },
  computed: {
    endorsementsDisplay() {
      return this.testData[this.selectedIndex].Endorsements.map((item) => {
        return `${item.Code} (${item.Description})`;
      }).join(', ');
    },
    addRestrictionsDisplay() {
      const filteredRestrictions = this.testData[
        this.selectedIndex
      ].Restrictions.filter((item) => {
        return item.Remove === false;
      });

      return filteredRestrictions
        .map((e) => {
          return `${e.Code} (${e.Description})`;
        })
        .join(', ');
    },
    removeRestrictionsDisplay() {
      const filteredRestrictions = this.testData[
        this.selectedIndex
      ].Restrictions.filter((item) => {
        return item.Remove === true;
      });

      return filteredRestrictions
        .map((e) => {
          return `${e.Code} (${e.Description})`;
        })
        .join(', ');
    },
  },
  methods: {
    goBack() {
      this.$emit('navigateTo', 'TestResults', this.testData);
    },
  },
};
</script>

<style scoped>
hr {
  display: block;
  height: 1px;
  background: transparent;
  width: 100%;
  border: none;
  border-top: solid 1px #aaa;
}

div,
span {
  color: black;
}
</style>
